/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Deal_WonInputs */

const cs_enum_deal_won = /** @type {(inputs: Enum_Deal_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchod vyhrán`)
};

const en_enum_deal_won = /** @type {(inputs: Enum_Deal_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal won`)
};

/**
* | output |
* | --- |
* | "Deal won" |
*
* @param {Enum_Deal_WonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_deal_won = /** @type {((inputs?: Enum_Deal_WonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Deal_WonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_deal_won(inputs)
	return cs_enum_deal_won(inputs)
});